const func = $target => {
    var ids = [];
    $target.find('[data-product-id]').each(function() {
        ids.push($(this).data('product-id'));
    });
    $.ajax({
        url: '/api/ecom/products',
        dataType: 'json',
        data: { ids: ids }
    }).done(function(data) {
        console.log(data);

        $.each(data.products, function() {
            $target.find('[data-product-id="' + this.id + '"] .price').text(this.salePrice);
            if (this.onSale) {
                var span = '<span class="small"><del>' + this.price + '</del></span><br>';
                $target.find('[data-product-id="' + this.id + '"] .price').before(span);
            }
        });
    });
};

export default func;